import React, {Component} from 'react';
import {Link} from 'react-router-dom';

export default class extends Component {
	render() {
		return (
			<div className="review review-question">
				<div className="question">
					Вам понравилось<br />у нас?
				</div>
				<div className="buttons">
					<Link to="/review/links" className="answer answer-yes">Да!</Link>
					<Link to="/review/dislike" className="answer answer-no">Нет</Link>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/review/Question.js